<template>
  <div class="animated fadeIn">
    <vLoading v-if="vLoading" />
    <div v-if="pageLoaded">
      <b-card style="border: 0" class="pa-5">
        <h3>
          <v-icon class="primary--text">mdi-cogs</v-icon>
          تنظیمات نقشه
        </h3>
        <hr />
        <v-row>
          <v-col>
            <div class="pa-5 blue-grey lighten-5" style="border-radius: 15px">
              <div class="d-flex">
                <label
                  class="font-weight-bold blue-grey--text text--darken-3 h5 mb-4"
                  >ماموریت‌های ستاد</label
                >
                <v-spacer></v-spacer>
                <v-btn
                  class="blue-btn me-2"
                  @click="openPreviewDialog('missions')"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
                <v-btn class="purple-btn" @click="openEditDialog('missions')"
                  ><v-icon>mdi-pencil-outline</v-icon></v-btn
                >
              </div>

              <p class="mt-4" v-html="mapInfo.missions"></p></div
          ></v-col>
        </v-row>
        <hr />
        <v-row
          ><v-col>
            <div class="pa-5 blue-grey lighten-5" style="border-radius: 15px">
              <div class="d-flex">
                <label
                  class="font-weight-bold blue-grey--text text--darken-3 h5 mb-4"
                  >نقش استان‌ها در توسعه زیست فناوری در کشور</label
                >
                <v-spacer></v-spacer>
                <v-btn
                  class="blue-btn me-2"
                  @click="openPreviewDialog('statesRole')"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >

                <v-btn class="purple-btn" @click="openEditDialog('statesRole')"
                  ><v-icon>mdi-pencil-outline</v-icon></v-btn
                >
              </div>
              <p class="mt-4" v-html="mapInfo.statesRole"></p></div></v-col
        ></v-row>
      </b-card>
    </div>
    <v-dialog v-model="previewDialog" width="600">
      <v-card class="map-modalCard pa-4">
        <v-row>
          <v-col class="text-right"> </v-col>
          <v-col class="text-left">
            <span @click="previewDialog = false">
              <v-icon class="pointer">$Close</v-icon>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <a href="https://isti.ir/" target="_blank">
              <img
                src="../../assets/images/header-right.png"
                style="width: 140px"
              />
            </a>
          </v-col>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <img src="../../assets/images/1403year.png" style="width: 130px" />
          </v-col>
          <v-col class="d-flex justify-content-center flex-column align-center">
            <a href="https://biodc.isti.ir/" target="_blank">
              <img src="../../assets/images/biodc.png" style="width: 140px" />
            </a>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col class="pt-0 text-center" cols="12">
            <h2 class="c-dark pb-1" style="border-bottom: 2px solid #666">
              {{ mapTitles[selectedKey] }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-html="mapInfo[selectedKey]"></div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" width="600">
      <v-card class="map-modalCard pa-4">
        <v-row>
          <v-col class="text-right"> </v-col>
          <v-col class="text-left">
            <span @click="editDialog = false">
              <v-icon class="pointer">$Close</v-icon>
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col class="pt-0 text-center" cols="12">
            <h3 class="c-dark pb-1" style="border-bottom: 2px solid #666">
              ویرایش
              {{ mapTitles[selectedKey] }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <vue-ckeditor v-model="selectedValue" :config="config" />
              <h6
                v-if="checkLength(selectedValue)"
                class="red--text mt-4 font-weight-bold"
              >
                عبارت مورد نظر تنها می‌تواند 600 حرف داشته‌ باشد.
              </h6>
            </div>
            <v-btn
              width="120"
              class="bc-green white--text font-weight-bold btn-radius mt-5 float-end"
              style="box-shadow: none !important"
              @click="submit()"
              :loading="loading2"
              :disabled="checkLength(selectedValue)"
              ><v-icon class="me-2">mdi-check</v-icon>
              ثبت
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCkeditor from "vue-ckeditor2";
export default {
  components: {
    VueCkeditor,
  },
  data() {
    return {
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      mapInfo: {},
      mapTitles: {
        missions: "ماموریت‌های ستاد",
        statesRole: "نقش استان‌ها در توسعه زیست فناوری در کشور",
      },
      loading: false,
      loading2: false,
      vLoading: false,
      pageLoaded: true,
      editDialog: false,
      previewDialog: false,
      selectedKey: null,
      selectedValue: "",
    };
  },
  methods: {
    submit() {
      this.loading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/option/add",
          {
            value: this.selectedValue,
            key: this.selectedKey,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.toast("تغییرات موردنظر با موفقیت ثبت شد.", "success");
            this.loading = false;
            this.editDialog = false;
            this.getInfo();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    getInfo() {
      this.vLoading = true;
      this.$http
        .get(this.baseUrl + "/setad/admin/option/getMapOptions", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.mapInfo = res.data;
          this.vLoading = false;
          setTimeout(() => {
            this.pageLoaded = true;
          }, 500);
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    checkLength(text) {
      if (text) {
        if (text.length) {
          let withoutSpace = text.replaceAll(/<\/?[^>]+(>|$)/g, "");
          withoutSpace = withoutSpace.replaceAll("&nbsp;", "");
          withoutSpace = withoutSpace.replaceAll(" ", "");
          let length = withoutSpace.length;
          if (length > 600) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    openPreviewDialog(key) {
      this.selectedKey = key;
      this.previewDialog = true;
    },
    openEditDialog(key) {
      this.selectedKey = key;
      this.selectedValue = this.mapInfo[key];
      this.editDialog = true;
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
